<template>
  <div :class="{ cb_checkout_success_page: showCustomBlueSuccessPage }">
    <CustomBlueCheckoutSuccess
      v-if="showCustomBlueSuccessPage"
      layout="computer"
      :repayment-data="repaymentData"
      :collection-data="collectionData"
      :country-info="countryInfo"
      :country-info-logo="countryInfoLogo"
      :format-bank-name="formatBankName"
    />
    <ThemePaymentAccountEntryPage
      v-else-if="showPaymentAccountEntryPage"
      v-model="paymentAccount"
      layout="computer"
      :repayment-data="repaymentData"
      :country-info="countryInfo"
      :country-info-logo="countryInfoLogo"
      :operator-list="operatorList"
      :phone-max-length="phoneMaxLength"
      :payment-amount="formattedPaymentAmount"
      :show-operator-list="hasOperatorList"
      @choose-operator="chooseOperator"
      @submit="onOpenPaymentAccountVerifyClick"
    />
    <ThemeCopyPayPage
      v-else-if="showThemeCopyPayPage"
      layout="computer"
      :repayment-data="repaymentData"
      :collection-data="collectionData"
      :collection-data-step="collectionDataStep"
      :country-info="countryInfo"
      :country-info-logo="countryInfoLogo"
      :hr="hr"
      :min="min"
      :sec="sec"
      :formatted-payment-amount="formattedPaymentAmount"
      :transaction-id-template="transactionIdTemplate"
      :transaction-id="transactionId"
      :is-submit-transaction-id="isSubmitTransactionId"
      :refresh-num="refreshNum"
      :show-error="showError"
      :is-hide-textarea="isHideTextarea"
      :sms-placeholder="getInputPlaceholder()"
      :collection-show="collectionShow"
      :collection-detail-show="collectionDetailShow"
      :payment-account-verify-show="paymentAccountVerifyShow"
      :user-submit-account-number="userSubmitAccountNumber"
      :pop-commit-text="popCommitText"
      :format-bank-name="formatBankName"
      @update:transaction-id-template="transactionIdTemplate = $event"
      @copy="onCopy"
      @refresh="refresh"
      @submit-transaction="onTransactionIdSubmitClick"
      @show-detail="getCollectedDetail"
      @get-results="getResults"
      @close-collection="collectionShow = false"
      @close-collection-detail="collectionDetailShow = false"
      @return-payment-account="paymentAccountVerifyReturn"
      @confirm-payment-account="onPaymentAccountVerifySubmitClick"
    />
    <div v-else class="computer_pay" :class="themeRootClass">
    <div
        class="computer_pay_header"
        :style="isCustomBlueTheme ? themeBannerStyle : (themeBannerStyle || {
        background: `url(${require('@/assets/banner.png')}) no-repeat`,
        backgroundSize: '100% 100%',
      })"
    >
      <div v-if="isCustomBlueTheme" class="computer_pay_header_cb">
        <img
            class="computer_pay_header_cb_logo"
            :src="
              repaymentData?.configData?.logoFileUrl
                ? repaymentData.configData.logoFileUrl
                : countryInfoLogo
            "
            alt=""
        />
      </div>
      <div v-else class="computer_pay_header_content">
        <div class="computer_pay_header_img_box">
          <img
              class="computer_pay_header_img"
              :src="
              repaymentData?.configData?.logoFileUrl
                ? repaymentData.configData.logoFileUrl
                : countryInfoLogo
            "
              alt=""
          />
          <!-- <div class="computer_pay_header_text">WE Pay</div> -->
        </div>
        <!--        <div class="computer_pay_header_time_repayment">Repayment</div>-->
        <div class="computer_pay_header_time_box">
          <div class="computer_pay_header_time_title">
            {{ $t('text_remaining_time') }}
          </div>
          <div class="computer_pay_header_time_info">
            <div class="computer_pay_header_time_item">
              <div class="computer_pay_header_time" v-if="hr">
                <div class="computer_pay_header_time_item">
                  {{ hr.toString()[0] }}
                </div>
                <div class="computer_pay_header_time_item">
                  {{ hr.toString()[1] }}
                </div>
              </div>
              <div class="computer_pay_header_text">:</div>
            </div>
            <div class="computer_pay_header_time_item">
              <div class="computer_pay_header_time" v-if="min">
                <div class="computer_pay_header_time_item">
                  {{ min.toString()[0] }}
                </div>
                <div class="computer_pay_header_time_item">
                  {{ min.toString()[1] }}
                </div>
              </div>
              <div class="computer_pay_header_text">:</div>
            </div>
            <div class="computer_pay_header_time_item">
              <div class="computer_pay_header_time" v-if="sec">
                <div class="computer_pay_header_time_item">
                  {{ sec.toString()[0] }}
                </div>
                <div class="computer_pay_header_time_item">
                  {{ sec.toString()[1] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isCustomBlueTheme" class="computer_pay_hero">
      <p class="computer_pay_hero_tagline">{{ checkoutPageTagline }}</p>
      <h1 class="computer_pay_hero_title">{{ checkoutPageTitle }}</h1>
      <p class="computer_pay_hero_subtitle">{{ checkoutPageSubtitle }}</p>
    </div>
    <div class="computer_pay_box" :class="{ computer_pay_box_cb: isCustomBlueTheme }">
      <div class="computer_pay_container" :class="{ computer_pay_container_cb: isCustomBlueTheme }">
        <div>
          <div v-if="!isCustomBlueTheme" class="computer_pay_container_step computer_pay_container_step_card">
            <div class="computer_pay_container_step_label">
              {{ $t('text_copy_pay') }}
            </div>
            <div class="computer_pay_container_step_value">
              {{ $t('text_copy_this_bank_name1') }}
              <span v-if="formatBankName(repaymentData?.cardData?.bankName) != countryInfo?.enName" class="computer_pay_container_step_value_bn">{{
                  formatBankName(repaymentData?.cardData?.bankName)
                }}</span>
              {{ $t('text_copy_this_bank_name2') }}
            </div>
          </div>
          <div class="computer_pay_container_step_item_line">
            <div
                class="computer_pay_container_step_item_box"
                :class="{ computer_pay_checkout_card: isCustomBlueTheme }"
            >
              <div v-if="isCustomBlueTheme" class="computer_pay_checkout_card_top">
                <div class="computer_pay_checkout_card_top_amount">
                  <div class="computer_pay_checkout_card_top_label">{{ checkoutAmountLabel }}</div>
                  <div class="computer_pay_checkout_card_top_value">
                    <span>{{ countryInfo?.currencyCode }}</span>{{ repaymentData?.cardData?.amount }}
                  </div>
                </div>
                <div class="computer_pay_checkout_card_top_countdown">
                  <div class="computer_pay_checkout_card_top_label">{{ checkoutCountdownLabel }}</div>
                  <div class="computer_pay_checkout_card_top_timer">
                    <template v-if="hr">
                      <span class="computer_pay_checkout_card_top_timer_item">{{ hr.toString().padStart(2, '0') }}</span>
                      <span class="computer_pay_checkout_card_top_timer_sep">:</span>
                    </template>
                    <span v-if="min" class="computer_pay_checkout_card_top_timer_item">{{ min.toString().padStart(2, '0') }}</span>
                    <span v-if="min || sec" class="computer_pay_checkout_card_top_timer_sep">:</span>
                    <span v-if="sec" class="computer_pay_checkout_card_top_timer_item">{{ sec.toString().padStart(2, '0') }}</span>
                  </div>
                </div>
              </div>
              <template v-if="countryInfo?.enName === 'TH'">
                <div class="computer_pay_container_step_item">
                  <div class="computer_pay_container_step_item_value">
                    <div style="font-size: 16px;" class="computer_pay_container_step_item_value_label">
                      {{ $t('text_order_amount') }}:
                    </div>
                    <div class="computer_pay_container_step_item_value_2">
                      <div style="font-size: 16px;color: #888888;"
                           class="computer_pay_container_step_item_value_2_info">
                        <span style="font-size: 16px;color: #888888;">{{ countryInfo?.currencyCode }}</span>
                        {{ repaymentData?.cardData?.amount }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="computer_pay_container_step_item">
                  <div class="computer_pay_container_step_item_value">
                    <div class="computer_pay_container_step_item_value_label">
                      <van-popover
                          v-model="showPopover"
                          theme="dark"
                          trigger="click"
                          placement="left-start"
                          class="computer_pay_container_step_item_value_label_popover"
                      >
                        <div class="computer_pay_container_step_item_value_label_popover_text">
                          {{ $t('text_please_use_payment') }}
                        </div>
                        <template #reference>
                          <van-icon class="computer_pay_container_step_item_value_label_icon" name="warning-o"/>
                        </template>
                      </van-popover>
                      {{ $t('text_payment_amount') }}:
                    </div>
                    <div class="computer_pay_container_step_item_value_2">
                      <div class="computer_pay_container_step_item_value_2_info">
                        <span>{{ countryInfo?.currencyCode }}</span>
                        {{ repaymentData?.cardData?.discountedAmount }}
                      </div>
                      <img @click="onCopy(repaymentData?.cardData?.discountedAmount)"
                           class="computer_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="computer_pay_container_step_item" v-if="repaymentData?.cardData?.accountName">
                  <div class="computer_pay_container_step_item_value">
                    <div class="computer_pay_container_step_item_value_label">
                      {{ $t('text_account_name') }}:
                    </div>
                    <div class="computer_pay_container_step_item_value_2">
                      <div class="computer_pay_container_step_item_value_2_info">
                        {{ repaymentData?.cardData?.accountName }}
                      </div>
                      <img v-if="!['NE', 'MZ', 'SL', 'EG'].includes(countryInfo?.enName)" @click="onCopy(repaymentData?.cardData?.accountName)"
                           class="computer_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="computer_pay_container_step_item">
                  <div class="computer_pay_container_step_item_value">
                    <div class="computer_pay_container_step_item_value_label">
                      {{ $t('text_bank_name') }}:
                    </div>
                    <div class="computer_pay_container_step_item_value_2">
                      <div class="computer_pay_container_step_item_value_2_info">
                        {{ repaymentData?.cardData?.bankAlias }}
                      </div>
                    </div>
                  </div>
                </div>
                <div ref="accountStep" class="computer_pay_container_step_item">
                  <div class="computer_pay_container_step_item_value">
                    <div class="computer_pay_container_step_item_value_label">
<!--                      {{-->
<!--                        formatBankName(repaymentData?.cardData?.bankName)-->
<!--                      }}-->
                      {{ $t('text_account') }}:
                    </div>
                    <div class="computer_pay_container_step_item_value_2">
                      <div class="computer_pay_container_step_item_value_2_info">
                        {{ repaymentData?.cardData?.accountNumber }}
                      </div>
                      <img @click="onCopy(repaymentData?.cardData?.accountNumber)"
                           class="computer_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                      <!--                    <div-->
                      <!--                        class="computer_pay_container_step_item_value_2_copy"-->
                      <!--                        @click="onCopy(repaymentData?.cardData?.accountNumber)"-->
                      <!--                    >-->
                      <!--                      {{ $t('text_copy') }}-->
                      <!--                    </div>-->
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="!isCustomBlueTheme" class="computer_pay_container_step_item">
                  <div class="computer_pay_container_step_item_value">
                    <div class="computer_pay_container_step_item_value_label">
                      {{ $t('text_total_amount') }}:
                    </div>
                    <div class="computer_pay_container_step_item_value_2">
                      <div class="computer_pay_container_step_item_value_2_info">
                        <span>{{ countryInfo?.currencyCode }}</span>
                        {{ repaymentData?.cardData?.amount }}
                      </div>
                      <img v-if="['NE', 'MZ', 'SL', 'EG'].includes(countryInfo?.enName)" @click="onCopy(repaymentData?.cardData?.amount)"
                           class="computer_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                    </div>
                  </div>
                </div>
                <div
                    v-if="isCustomBlueTheme"
                    class="computer_pay_checkout_card_bottom"
                >
                  <div
                      ref="accountStep"
                      class="computer_pay_container_step_item computer_pay_checkout_payee"
                  >
                    <div class="computer_pay_container_step_item_value">
                      <div class="computer_pay_checkout_card_top_label computer_pay_checkout_payee_label">
                        {{ checkoutPayeePrefix }} {{ formatBankName(repaymentData?.cardData?.bankName) }}
                      </div>
                      <div class="computer_pay_container_step_item_value_2">
                        <div class="computer_pay_container_step_item_value_2_info">
                          {{ repaymentData?.cardData?.accountNumber }}
                        </div>
                        <div
                            class="computer_pay_checkout_copy"
                            @click="onCopy(repaymentData?.cardData?.accountNumber)"
                        >
                          {{ checkoutCopyLabel }} →
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      class="computer_pay_container_step_item computer_pay_checkout_holder"
                      v-if="repaymentData?.cardData?.accountName"
                  >
                    <div class="computer_pay_container_step_item_value">
                      <div class="computer_pay_checkout_card_top_label computer_pay_checkout_holder_label">
                        {{ checkoutAccountHolderLabel }}
                      </div>
                      <div class="computer_pay_container_step_item_value_2">
                        <div class="computer_pay_container_step_item_value_2_info">
                          {{ repaymentData?.cardData?.accountName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-else>
                  <div
                      ref="accountStep"
                      class="computer_pay_container_step_item"
                  >
                    <div class="computer_pay_container_step_item_value">
                      <div class="computer_pay_container_step_item_value_label">
                        {{ formatBankName(repaymentData?.cardData?.bankName) }}
                        {{ $t('text_account') }}:
                      </div>
                      <div class="computer_pay_container_step_item_value_2">
                        <div class="computer_pay_container_step_item_value_2_info">
                          {{ repaymentData?.cardData?.accountNumber }}
                        </div>
                        <img
                            @click="onCopy(repaymentData?.cardData?.accountNumber)"
                            class="computer_pay_container_step_item_value_2_copy"
                            src="@/assets/copy.png"
                            alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div
                      class="computer_pay_container_step_item"
                      v-if="repaymentData?.cardData?.accountName"
                  >
                    <div class="computer_pay_container_step_item_value">
                      <div class="computer_pay_container_step_item_value_label">
                        {{ $t('text_account_name') }}:
                      </div>
                      <div class="computer_pay_container_step_item_value_2">
                        <div class="computer_pay_container_step_item_value_2_info">
                          {{ repaymentData?.cardData?.accountName }}
                        </div>
                        <img v-if="!['NE', 'MZ', 'SL', 'EG'].includes(countryInfo?.enName)" @click="onCopy(repaymentData?.cardData?.accountName)"
                             class="computer_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                      </div>
                    </div>
                  </div>
                </template>
              </template>
              <div class="computer_pay_container_step_item" v-if="repaymentData?.cardData?.agentAccountId">
                <div class="computer_pay_container_step_item_value">
                  <div class="computer_pay_container_step_item_value_label">
                    {{ $t('text_agent_id') }}:
                  </div>
                  <div class="computer_pay_container_step_item_value_2">
                    <div class="computer_pay_container_step_item_value_2_info">
                      {{ repaymentData?.cardData?.agentAccountId }}
                    </div>
                    <img @click="onCopy(repaymentData?.cardData?.agentAccountId)"
                         class="computer_pay_container_step_item_value_2_copy" src="@/assets/copy.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div v-if="repaymentData?.cardData?.cmdCode" @click="onDial" class="computer_pay_container_dial">
              {{ $t('text_click_pay') }}
            </div>
            <div v-if="repaymentData?.cardData?.cmdCode" class="computer_pay_container_dial_text">
              {{ getDial() }}
              <img @click="onCopy(getDial())" class="computer_pay_container_dial_text_img" src="@/assets/copy.png"
                   alt="">
            </div>
          </div>

          <div class="computer_pay_container_step computer_pay_container_step_refresh">
            <div class="computer_pay_container_step_label">
              {{ $t('text_payment_completed') }}
            </div>
            <div
                v-if="collectionDataStep==0"
                class="computer_pay_container_step_value"
            >
              {{ $t('text_click') }}
              <span class="computer_pay_container_step_value_bn">"{{ $t('text_refresh') }}"</span>
              {{ $t('text_check_successful') }}
            </div>
            <div
                v-if="collectionDataStep==1"
                class="computer_pay_container_step_value"
            >
              {{ $t('text_check_successful2') }}
            </div>
          </div>
          <div class="computer_pay_container_step_item_line">
            <div class="computer_pay_container_step_item_box">

              <div ref="refreshStep" class="computer_pay_container_step_account_box">
                <div class="computer_pay_container_step_account_label">
                  {{ $t('text_amount_paid') }}:
                </div>
                <div class="computer_pay_container_step_account_box_2">
                  <div class="computer_pay_container_step_account_label_2">
                  <span v-if="collectionDataStep==0">
                    <span style="font-size: 22px;">{{ countryInfo?.currencyCode }}</span> {{
                      collectionData.collectedAmount
                    }}
                  </span>
                    <span v-if="collectionDataStep==1" style="color: #E68608;">
                    <span style="font-size: 22px;">{{ countryInfo?.currencyCode }}</span> {{
                        collectionData.collectedAmount
                      }}
                  </span>
                  </div>
                  <div @click="refresh" v-if="collectionDataStep==0"
                       class="computer_pay_container_step_account_label_3">
                    {{ $t('text_refresh') }}
                  </div>
                  <img v-if="collectionDataStep==1" class="computer_pay_container_step_account_label_4"
                       src="@/assets/1119/success.png" alt="">
                </div>
                <div v-if="collectionDataStep==0" class="computer_pay_container_step_account_box_3">
                  {{ $t('text_expected_payment') }}
<!--                  <template v-if="refreshNum == 1">{{ $t('text_please_try_again') }}</template>-->
                </div>
              </div>

              <!-- <div v-if="refreshNum == 1 || showError" class="computer_pay_container_step_account_box_8">{{ $t('text_please_try_again2') }}</div> -->

            <template v-if="!isHideTextarea && (refreshNum != 0 || transactionId)">
                <div class="computer_pay_container_step_account_box_4">
                  {{ $t('text_get_results_faster') }}
                </div>
                <div class="computer_pay_container_step_account_box_5">
                  {{ $t('text_fill_payment') }}
                </div>
                <div class="computer_pay_container_step_account">
                  <!-- <div class="computer_pay_container_step_account_input_desc">
                    After payment, please enter the Transaction ID
                  </div> -->
                  <div
                      v-if="!isSubmitTransactionId"
                      class="computer_pay_container_step_account_input_box computer_pay_container_step_account_input_box2"
                  >
                <textarea
                    style="resize: none"
                    v-model="transactionIdTemplate"
                    class="computer_pay_container_step_account_input"
                    type="textarea"
                    :placeholder="getInputPlaceholder()"
                />
                  </div>
                  <div class="computer_pay_container_step_account_submit_box">
                    <div
                        v-if="!isSubmitTransactionId"
                        class="computer_pay_container_step_sms_example_desc"
                    >
                      <span>*</span>{{ $t('text_fill_wrong_payment') }}
                    </div>
                    <div
                        v-if="!isSubmitTransactionId"
                        @click="onTransactionIdSubmitClick"
                        class="computer_pay_container_step_account_submit computer_pay_container_step_account_submit3"
                    >
                      <div class="computer_pay_container_step_account_submit_text">
                        {{ $t('text_submit') }}
                        <img
                            class="computer_pay_container_step_account_submit_text_img"
                            src="@/assets/1119/arrow.png"
                            alt=""
                        />
                      </div>

                      <!--            <img class="computer_pay_container_step_account_submit_img" src="@/assets/submit.png"-->
                      <!--                 alt="">-->
                    </div>
                  </div>
                </div>

                <template v-if="isSubmitTransactionId">
                  <div class="computer_pay_container_step_account">
                    <div
                        class="computer_pay_container_step_account_input_box computer_pay_container_step_account_input_box2">
                <textarea
                    style="resize: none;border-radius: 8px;"
                    v-model="transactionIdTemplate"
                    class="computer_pay_container_step_account_input"
                    type="textarea"
                    readonly
                />
                    </div>
                  </div>
                  <div class="computer_pay_container_step_account_box_6">
                    {{ $t('text_transaction_id') }}:
                  </div>
                  <div class="computer_pay_container_step_account">
                    <div
                        class="computer_pay_container_step_account_input_box computer_pay_container_step_account_input_box2 computer_pay_container_step_account_input_box_s">
                <textarea
                    style="resize: none;color: #E68608;border-radius: 8px;"
                    v-model="transactionId"
                    class="computer_pay_container_step_account_input"
                    type="textarea"
                    readonly
                />
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </div>

          <div v-if="!['TH'].includes(countryInfo?.enName)"
               class="computer_pay_container_step computer_pay_container_step_box_account"
               :class="{ computer_pay_container_step_box_account_cb: isCustomBlueTheme }">
            <div class="computer_pay_container_step_label">
              <template v-if="isCustomBlueTheme">{{ checkoutAccountSectionLabel }}</template>
              <template v-else>{{ $t('text_your_payment_account') }}:</template>
            </div>
            <div v-if="isCustomBlueTheme" class="computer_pay_wallet_cb_card">
              <div class="computer_pay_wallet_cb_label">{{ checkoutWalletLabel }}</div>
              <div class="computer_pay_container_step_accountnumber computer_pay_wallet_cb_value">
                {{ repaymentData?.cardData?.userSubmitAccountNumber }}
              </div>
            </div>
            <div
              v-if="isCustomBlueTheme && collectionDataStep == 0"
              class="computer_pay_wallet_cb_confirm_btn"
              @click="refresh"
            >
              {{ paymentAccountPopupSubmitText }}
            </div>
          </div>
          <div v-if="!['TH'].includes(countryInfo?.enName) && repaymentData?.cardData?.tipsContent && !isCustomBlueTheme"
               class="computer_pay_container_step_item_line">
            <div class="computer_pay_container_step_item_box">
              <div class="computer_pay_container_step_accountnumber">
                {{ repaymentData?.cardData?.userSubmitAccountNumber }}
              </div>
            </div>
          </div>
          <div v-if="!['TH'].includes(countryInfo?.enName) && !repaymentData?.cardData?.tipsContent && !isCustomBlueTheme">
            <div class="computer_pay_container_step_accountnumber">
              {{ repaymentData?.cardData?.userSubmitAccountNumber }}
            </div>
          </div>
          <div v-if="repaymentData?.cardData?.tipsContent && !isCustomBlueTheme"
               class="computer_pay_container_step computer_pay_container_step_box_tipsContent">
            <div class="computer_pay_container_step_label">
              {{ $t('text_payment_reminder') }}
            </div>
            <div class="computer_pay_container_step_value computer_pay_container_step_item_box" v-html="processedTipsContent">
            </div>
          </div>
        </div>
      </div>

      <div v-if="isSubmitTransactionId" class="computer_pay_container_result">
        <div class="computer_pay_container_result_info">
          {{ $t('text_amount_received') }}:
          <div class="computer_pay_container_result_info_content">
            <span>{{ countryInfo?.currencyCode }}</span>
            <div class="computer_pay_container_result_info_amount">
              {{
                repaymentData?.cardData?.collectedAmount
                    ? repaymentData?.cardData?.collectedAmount
                    : 0
              }}
            </div>
            <div
                class="computer_pay_container_result_info_btn"
                @click="getCollectedDetail"
            >
              {{ $t('text_details') }}
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="isSubmitTransactionId"
          @click="getResults"
          class="computer_pay_container_result_submit"
      >
        <div class="computer_pay_container_result_submit_text">{{ $t('text_get_details') }}</div>
        <img
            class="computer_pay_container_result_submit_img"
            src="@/assets/1119/submit.png"
            alt=""
        />
      </div>
      <div v-if="isSubmitTransactionId" class="computer_pay_container_tips">
        <img
            class="computer_pay_container_tips_img"
            src="@/assets/1119/tips.png"
            alt=""
        />
        {{ $t('text_click_result_transfer') }}
      </div>
    </div>

    <!--    付款账号-->
    <van-popup get-container="body" v-model="paymentAccountShow" :close-on-click-overlay="false">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div v-if="!isCustomBlueTheme" class="computer_pay_payment_account_popup_main_logo">
            <img
                class="computer_pay_payment_account_popup_main_logo_img"
                :src="
                repaymentData?.configData?.logoFileUrl
                  ? repaymentData.configData.logoFileUrl
                  : countryInfoLogo
              "
                alt=""
            />
          </div>
          <div class="computer_pay_payment_account_popup_main_title">
            {{ paymentAccountPopupTitle }}
          </div>
          <!-- <div class="computer_pay_payment_account_popup_main_desc">
            Enter your actual payment account to complete the payment.
          </div> -->
          <div class="computer_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_payment_amount') }}:<span>{{ countryInfo?.currencyCode }}</span>
            <span
                class="computer_pay_payment_account_popup_main_wait_amount_num"
            >{{ formattedPaymentAmount }}</span
            >
          </div>
          <div class="paymentMethod" v-if="hasOperatorList">
            <div class="paymentMethod_title">{{ $t('text_please_select_payment_method') }}</div>
            <div class="paymentMethod_box">
              <div class="paymentMethod_item" :class="item.isSelect && 'paymentMethod_item_s'"
                   v-for="(item,index) in operatorList" @click="chooseOperator(index)" :key="index">
                <img class="paymentMethod_item_logo" :src="item.logo" alt="">
                <div class="paymentMethod_item_name">{{ item.name }}</div>

                <img v-if="item.isSelect" class="paymentMethod_item_true" :src="paymentMethodSelectedImg" alt="">
              </div>
            </div>
          </div>
          <div v-if="repaymentData.extraParams?.includes('customerAccountNumber')"
               class="computer_pay_container_step_account">
            <div class="computer_pay_container_step_account_input_box">
              <div class="computer_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
              <input
                  v-model="paymentAccount"
                  class="computer_pay_container_step_account_input"
                  type="text"
                  :maxlength="phoneMaxLength"
                  :placeholder="paymentAccountPopupInputPlaceholder"
              />
            </div>
            <div
                @click="onOpenPaymentAccountVerifyClick"
                class="computer_pay_container_step_account_submit"
            >
              <div class="computer_pay_container_step_account_submit_text">
                {{ paymentAccountPopupSubmitText }}
              </div>
              <img
                  class="computer_pay_container_step_account_submit_img"
                  src="@/assets/cardPay_GH/submit.png"
                  alt=""
              />
            </div>
          </div>
          <div class="computer_pay_container_step_pay_account">
            <img
                v-if="showPaymentAccountPopupWarningIcon"
                class="computer_pay_container_step_pay_account_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            <template v-if="paymentAccountPopupWarning">{{ paymentAccountPopupWarning }}</template>
            <template v-else>
              {{ $t('text_please_fill_your_payment') }}
              {{ $t('text_please_fill_your_payment2') }}
            </template>
          </div>
          <div style="height: 70px"></div>
        </div>
      </div>
    </van-popup>

    <!--    transactionId二次确认-->
    <van-popup get-container="body"
               v-model="transactionIdTemplateShow"
               :close-on-click-overlay="false"
    >
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <img
              @click="transactionIdTemplateShow = false"
              class="computer_pay_payment_account_popup_main_close"
              src="@/assets/1231/close.png"
              alt=""
          />
          <div class="computer_pay_payment_account_popup_main_logo">
            <img
                class="computer_pay_payment_account_popup_main_logo_img"
                src="@/assets/1231/sms.png"
                alt=""
            />
          </div>
          <div class="computer_pay_payment_account_popup_main_title">
            {{ $t('text_payment_sms') }}:
          </div>
          <div class="computer_pay_payment_account_popup_main_desc">
            {{ transactionIdTemplate }}
          </div>
          <!-- <div class="computer_pay_payment_account_popup_main_desc">
            Enter your actual payment account to complete the payment.
          </div> -->
          <div class="computer_pay_payment_account_popup_main_wait_amount">
            {{ $t('text_transaction_id') }}:
          </div>
          <div
              class="computer_pay_container_step_account computer_pay_container_step_account2"
          >
            <div class="computer_pay_container_step_account_input_box">
              <input
                  v-model="transactionId"
                  class="computer_pay_container_step_account_input"
                  type="text"
                  :placeholder="$t('text_fill_payment')"
              />
            </div>
            <div
                @click="onTransactionIdSubmitTwoClick"
                class="computer_pay_container_step_account_submit computer_pay_container_step_account_submit2"
            >
              <div class="computer_pay_container_step_account_submit_text">
                {{ $t('text_confirm') }}
              </div>
            </div>
          </div>
          <div style="height: 70px"></div>
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body"
               v-model="paymentAccountVerifyShow"
               :close-on-click-overlay="false"
    >
      <div class="computer_pay_payment_account_verify_popup">
        <div class="computer_pay_payment_account_verify_popup_main">
          <div class="computer_pay_payment_account_verify_popup_main_title">
            {{ $t('text_please_confirm_will_following_account_transfer') }}
          </div>
          <!-- <div class="computer_pay_payment_account_verify_popup_main_item">
            <div class="computer_pay_payment_account_verify_popup_main_item_label">votre mode de paiement:</div>
            <div class="computer_pay_payment_account_verify_popup_main_item_value">{{ userSubmitOperator }}</div>
          </div> -->
          <div class="computer_pay_payment_account_verify_popup_main_item">
            <div
                class="computer_pay_payment_account_verify_popup_main_item_label"
            >
              {{ $t('text_your_payment_account') }}:
            </div>
            <div
                class="computer_pay_payment_account_verify_popup_main_item_value"
            >
              {{ userSubmitAccountNumber }}
            </div>
          </div>
          <div class="computer_pay_payment_account_verify_popup_main_btnBox">
            <div
                class="computer_pay_payment_account_verify_popup_main_btn"
                @click="paymentAccountVerifyReturn"
            >
              {{ $t('text_return') }}
            </div>
            <div
                class="computer_pay_payment_account_verify_popup_main_btn computer_pay_payment_account_verify_popup_main_btn2"
                :class="
                timerOut != 3 &&
                'computer_pay_payment_account_verify_popup_main_btn2_ban'
              "
                @click="onPaymentAccountVerifySubmitClick"
            >
              {{ popCommitText }}
            </div>
          </div>
          <!--          <div style="height: 20px;"></div>-->
        </div>
      </div>
    </van-popup>
    <van-popup get-container="body" v-model="editAccountShow">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div class="computer_pay_payment_account_popup_main_title">
            Modify Payment Account
          </div>
          <div class="computer_pay_payment_account_popup_main_cur_account">
            Current account:<span>{{
              repaymentData?.paymentData?.userSubmitAccountNumber
            }}</span>
          </div>
          <div class="computer_pay_container_step_account">
            <div class="computer_pay_container_step_account_input_box">
              <div class="computer_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
              <input
                  v-model="editAccountNumber"
                  class="computer_pay_container_step_account_input"
                  type="text"
                  maxlength="10"
                  :placeholder="$t('text_please_enter_your_actual_payment_account')"
              />
            </div>
            <div
                @click="editAccountSubmit"
                class="computer_pay_container_step_account_submit"
            >
              <div class="computer_pay_container_step_account_submit_text">
                {{ $t('text_confirm') }}
              </div>
              <img
                  class="computer_pay_container_step_account_submit_img"
                  src="@/assets/cardPay_GH/submit.png"
                  alt=""
              />
            </div>
          </div>
          <div style="height: 60px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
              class="computer_pay_payment_account_popup_close"
              @click="editAccountShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" v-model="editAccountConfirmShow">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div class="computer_pay_payment_account_popup_main_title">
            <img
                class="computer_pay_payment_account_popup_main_title_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            Remind
          </div>
          <div
              class="computer_pay_payment_account_popup_main_collect_confirm_box"
          >
            The payment account can only be changed once, are you sure you want
            to change it to
            <span>{{ editAccountNumber }}</span
            >?
          </div>
          <div class="computer_pay_payment_account_popup_main_confirm_box">
            <div
                @click="onSubmitEditTrxNoClick"
                class="computer_pay_container_step_account_submit"
            >
              <div class="computer_pay_container_step_account_submit_text">
                {{ $t('text_confirm') }}
              </div>
              <img
                  class="computer_pay_container_step_account_submit_img"
                  src="@/assets/cardPay_GH/submit.png"
                  alt=""
              />
            </div>
          </div>
          <div style="height: 50px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
              class="computer_pay_payment_account_popup_close"
              @click="editAccountConfirmShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" v-model="collectionShow">
      <div class="computer_pay_payment_account_popup">
        <div
            class="computer_pay_payment_account_popup_main"
            v-if="collectionDataStep == 0"
        >
          <div class="computer_pay_payment_account_popup_main_title">
            <img
                class="computer_pay_payment_account_popup_main_title_img"
                src="@/assets/cardPay_NG/danger.png"
                alt=""
            />
            No payment received
          </div>
          <div class="computer_pay_payment_account_popup_main_collect_box">
            <div class="computer_pay_payment_account_popup_main_collect_num">
              Please check whether your payment account and actual payment
              amount are correct.
            </div>
            <div class="computer_pay_payment_account_popup_main_collect_total">
              Payment account:<span>
                <!-- {{
                repaymentData?.paymentData?.userSubmitAccountNumber
              }} -->
                {{ repaymentData?.cardData?.accountNumber }}</span
            >
              <div
                  @click="editAccountShow = true"
                  v-if="repaymentData?.paymentData?.canEditAccountNumberNumber"
                  class="computer_pay_payment_account_popup_main_collect_total_edit"
              >
                <img
                    class="computer_pay_payment_account_popup_main_collect_total_edit_img"
                    src="@/assets/cardPay_GH/edit.png"
                />Modify
              </div>
            </div>
          </div>
          <div style="height: 60px"></div>
        </div>
        <div
            class="computer_pay_payment_account_popup_main"
            v-if="collectionDataStep == 1"
        >
          <div class="computer_pay_payment_account_popup_main_title">
            Get results
          </div>
          <div class="computer_pay_payment_account_popup_main_collect_box">
            <div class="computer_pay_payment_account_popup_main_collect_num">
              {{ collectionData.transactionNums }} transfer received
            </div>
            <div class="computer_pay_payment_account_popup_main_collect_total">
              Total amount:<span>{{ countryInfo?.currencyCode }} </span
            ><span
                class="computer_pay_payment_account_popup_main_collect_total_amount"
            >{{ collectionData.collectedAmount }}</span
            >
              <div
                  @click="collectionDetailShow = true"
                  class="computer_pay_payment_account_popup_main_collect_total_detail"
              >
                Detail
              </div>
            </div>
          </div>
          <div style="height: 60px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
              class="computer_pay_payment_account_popup_close"
              @click="collectionShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    <van-popup get-container="body" v-model="collectionDetailShow">
      <div class="computer_pay_payment_account_popup">
        <div class="computer_pay_payment_account_popup_main">
          <div
              class="computer_pay_payment_account_popup_main_title computer_pay_payment_account_popup_main_detail_title"
          >
            {{ $t('text_collection_details') }}
          </div>
          <div class="data-box">
            <van-row class="th-row">
              <van-col>{{ $t('text_order_number') }}</van-col>
              <van-col>{{ $t('text_debit_account') }}</van-col>
              <van-col>{{ $t('text_remittance_amount') }}</van-col>
              <van-col>{{ $t('text_payment_time') }}</van-col>
            </van-row>

            <van-row
                class="td-row"
                :style="{ background: index % 2 == 0 ? '#fff' : '#f1f1f1' }"
                v-for="(item, index) in collectionData.collectDetails"
                :key="index"
            >
              <van-col class="common-ellipsis">{{
                  item.bankTransactionReference
                }}
              </van-col>
              <van-col class="common-ellipsis">{{
                  item.destinationAccountNumber
                }}
              </van-col>
              <van-col class="common-ellipsis">{{ item.amount }}</van-col>
              <van-col class="common-ellipsis">{{
                  item.transactionTime
                }}
              </van-col>
            </van-row>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div class="computer_pay_payment_account_popup_close_box">
          <img
              class="computer_pay_payment_account_popup_close"
              @click="collectionDetailShow = false"
              src="@/assets/cardPay_GH/close.png"
          />
        </div>
      </div>
    </van-popup>

    </div>
    <FloatBall v-if="isShowBall && !showCustomBlueSuccessPage">
      <!-- 自定义悬浮球内容 -->
      <img v-if="floatBallImg" @click.stop="handleBallClick" @dragstart.prevent style="width: 100%;height: 100%;" :src="floatBallImg"
           alt="">
      <button v-else type="button" class="float-ball-text" @click.stop="handleBallClick">
        {{ floatBallText }}
      </button>
    </FloatBall>
  </div>
</template>

<script>
import logic from "./index.js";

export default {
  name: "DisplayLogicCardpayComputer",
  mixins: [logic],
};
</script>

<style lang="scss" scoped>
@import "./index.scss";

.computer_pay {
  position: relative;
  height: 100%;
  // height: 100vh;
  background-color: #f5f5f5;

  .computer_pay_header {
    width: 100%;
    height: 648px;
    padding-bottom: 16px;
    box-sizing: border-box;
    // background: url("~@/assets/cardPay_GH/header.png") no-repeat;
    background-size: 100% 100%;

    .computer_pay_header_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 100%;
      height: 144px;
      background: rgba(0, 0, 0, 0.3);

      .computer_pay_header_img_box {
        display: flex;
        align-items: center;
        justify-content: center;
        // margin-bottom: 20px;
        margin-left: 30px;

        .computer_pay_header_img {
          // width: 54px;
          height: 80px;
          border-radius: 15px;
        }

        .computer_pay_header_text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 26px;
          color: #72695f;

          span {
            color: #f03024;
            margin-left: 10px;
          }
        }
      }

      .computer_pay_header_time_box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;

        .computer_pay_header_time_title {
          width: 278px;
          height: 38px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #e5e5e5;

          background: url("~@/assets/cardPay_GH/tansaction.png") no-repeat;
          background-size: 100% 100%;

          display: flex;
          align-items: center;
          justify-content: center;
        }

        .computer_pay_header_time_info {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-top: 10px;
          // margin-left: 30px;
          width: 100%;

          .computer_pay_header_time_item {
            position: relative;
            background-size: 100% 100%;
            margin-right: 5px;
            display: flex;
            align-items: center;

            .computer_pay_header_time {
              font-size: 24px;
              font-family: LucidaGrande;
              color: #eeeeee;

              display: flex;
              align-items: center;
              margin-right: 5px;

              .computer_pay_header_time_item {
                width: 30px;
                height: 36px;
                background: rgba(255, 255, 255, 0.15);
                border-radius: 2px;
                border: 1px solid rgba(255, 255, 255, 0.5);

                display: flex;
                align-items: center;
                justify-content: center;
              }
            }

            .computer_pay_header_text {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 36px;
              color: #e5e5e5;
              margin-right: 5px;
              transform: translateY(-4px);
            }
          }

          .computer_pay_header_time_left {
            font-size: 18px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #e5e5e5;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .computer_pay_box {
    transform: translateY(-484px);
    margin: 0 auto;
    width: calc(100% - 50px);
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    box-sizing: border-box;
    padding-bottom: 25px;
  }

  .computer_pay_container {
    position: relative;
    padding-top: 25px;
    display: flex;
    align-items: center;
    justify-content: center;

    .computer_pay_container_step {
      //display: flex;
      //align-items: center;
      margin-bottom: 10px;
      //padding: 0 145px;
      box-sizing: border-box;

      &:nth-child(n + 2) {
        margin-top: 36px;
      }

      .computer_pay_container_step_label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 25px;
        color: #333333;
      }

      .computer_pay_container_step_accountnumber {
        margin-top: 4px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #E68608;
      }

      .computer_pay_container_step_value {
        margin-top: 4px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #8D8D8D;
        word-wrap: break-word;
        word-break: break-all;
        overflow-wrap: break-word;
        white-space: normal;
        max-width: 600px;

        span {
          color: #E72E2E;
        }
      }
    }

    .computer_pay_container_step_card {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -18px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/card_m.png") no-repeat;
        background-size: 100% 100%;
        width: 48px;
        height: 48px;
      }
    }

    .computer_pay_container_step_refresh {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -18px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/refresh_m.png") no-repeat;
        background-size: 100% 100%;
        width: 48px;
        height: 48px;
      }
    }

    .computer_pay_container_step_box_account {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -18px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/account.png") no-repeat;
        background-size: 100% 100%;
        width: 48px;
        height: 48px;
      }
    }

    .computer_pay_container_step_box_tipsContent {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        left: -18px;
        transform: translateX(-100%);
        content: "";
        background: url("~@/assets/1119/tipsContent.png") no-repeat;
        background-size: 100% 100%;
        width: 48px;
        height: 48px;
      }
    }

    .computer_pay_container_step_item_line {
      position: relative;

      &::after {
        position: absolute;
        top: -28px;
        left: -40px;
        transform: translateX(-100%);
        content: "";
        width: 1px;
        height: calc(100% + 66px);
        background: linear-gradient(
                to bottom,
                transparent 0%,
                transparent 50%,
                #99a1ab 50%,
                #99a1ab 100%
        );
        background-size: 1px 10px;
        background-repeat: repeat-y;
      }
    }

    .computer_pay_container_dial {
      margin: 0 auto;
      margin-top: 15px;
      padding: 15px 30px;
      box-sizing: border-box;
      background: #e68608;
      border-radius: 30px;
      border: 1px solid #e68608;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #ffffff;

      position: relative;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    .computer_pay_container_dial_text {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #e68608;

      .computer_pay_container_dial_text_img {
        width: 40px;
        height: 40px;
        margin-left: 12px;
      }
    }

    .computer_pay_container_step_item_box {
      //margin: 0 145px;
      padding: 20px 30px;
      box-sizing: border-box;

      width: 600px;
      background: #f5f5f5;
      border-radius: 8px;


      .computer_pay_container_step_account_box {
        .computer_pay_container_step_account_label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
        }

        .computer_pay_container_step_account_box_2 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 5px;
          margin-bottom: 5px;
          box-sizing: border-box;
          border-bottom: 1px solid #cccccc;

          .computer_pay_container_step_account_label_2 {
            font-family: Helvetica, Helvetica;
            font-weight: bold;
            font-size: 32px;
            color: #CCCCCC;
          }

          .computer_pay_container_step_account_label_3 {
            margin-top: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            cursor: pointer;

            width: 100px;
            height: 34px;
            background: #E68608;
            border-radius: 17px;
            border: 1px solid #E68608;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 15px;
            color: #FFFFFF;
          }

          .computer_pay_container_step_account_label_4 {
            width: 30px;
            height: 30px;

          }
        }

        .computer_pay_container_step_account_box_3 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #999999;
        }
      }

      .computer_pay_container_step_account_box_4 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 25px;
        color: #E68608;
        margin-bottom: 4px;
        margin-top: 20px;
      }

      .computer_pay_container_step_account_box_5 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        margin-bottom: 10px;
      }
      .computer_pay_container_step_account_box_8 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: red;
        margin-bottom: 10px;
      }

      .computer_pay_container_step_account_box_6 {
        margin-top: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 25px;
        color: #333333;
        margin-bottom: 10px;
      }

      .computer_pay_container_step_item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        .computer_pay_container_step_item_value {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #dc811d;

          span {
            font-size: 20px;
          }

          .computer_pay_container_step_item_value_2 {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 10px;

            .computer_pay_container_step_item_value_2_info {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 32px;
              color: #e68608;

              span {
                font-size: 24px;
              }
            }

            .computer_pay_container_step_item_value_2_copy {
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;

              margin-left: 15px;

              //width: 80px;
              //height: 34px;
              //background: #E68608;
              //border-radius: 17px;
              //border: 1px solid #E68608;
              //
              //font-family: PingFangSC, PingFang SC;
              //font-weight: 500;
              //font-size: 16px;
              //color: #FFFFFF;
              width: 40px;
              height: 40px;
            }
          }

          .computer_pay_container_step_item_value_label {
            margin-top: 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 18px;
            color: #888888;
            margin-right: 6px;
          }
        }

        .computer_pay_container_step_item_img {
          width: 78px;
          height: 32px;
          margin-left: 20px;
          cursor: pointer;
        }
      }

      .computer_pay_container_step_transfer {
        .computer_pay_container_step_item_value {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #555555;

          span {
            color: #dc811d;
            margin: 0 8px;
          }

          .computer_pay_container_step_transfer_btn {
            cursor: pointer;
            padding: 6px 15px;
            box-sizing: border-box;

            background: rgba(220, 129, 29, 0.12);
            border-radius: 18px;
            margin-right: 8px;

            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #dc811d;

            display: flex;
            align-items: center;
            justify-content: center;

            .computer_pay_container_step_transfer_btn_img {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
          }
        }
      }
    }

    .computer_pay_container_step_account_input_desc {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #888888;
    }

    .computer_pay_container_step_sms_example {
      margin-top: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #555555;
    }

    .computer_pay_container_step_sms_example_content {
      position: relative;
      margin-top: 10px;
      border-radius: 8px;

      width: 427px;
      background: #f5f5f5;
      border: 1px solid #dddddd;
      padding: 10px 12px;
      box-sizing: border-box;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      line-height: 25px;

      .computer_pay_container_step_sms_example_content_copy {
        position: absolute;
        top: 34px;
        left: 34px;
        width: 60px;
        height: 36px;
        background: rgba(0, 0, 0, 0.55);
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;

        &:before {
          position: absolute;
          top: 0;
          transform: translateY(-100%);
          content: "";

          width: 0;
          height: 0;
          border-left: 10px solid transparent; /* 左边框 */
          border-right: 10px solid transparent; /* 右边框 */
          border-bottom: 10px solid rgba(0, 0, 0, 0.55); /* 底边框，颜色为蓝色 */
        }
      }

      span {
        color: #ffffff;
        background: #6e86a1;
      }
    }

    .computer_pay_container_step_sms_example_desc {
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #555555;

      span {
        color: red;
      }
    }

    .computer_pay_container_step_account {
      box-sizing: border-box;

      .computer_pay_container_step_account_input_box {
        display: flex;
        align-items: center;
        margin-right: 20px;

        width: 100%;
        height: 150px;
        display: flex;
        align-items: center;
        margin-right: 20px;
        margin-top: 10px;

        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #cccccc;

        padding: 4px 6px;
        padding-right: 8px;
        box-sizing: border-box;
      }

      .computer_pay_container_step_account_input_box_s {
        height: 50px;

        .computer_pay_container_step_account_input {
          height: 50px;
          line-height: 50px;
          padding: 0;
          padding-left: 18px;
        }
      }

      .computer_pay_container_step_233 {
        width: 100px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #dc811d;
        text-align: center;
      }

      .computer_pay_container_step_account_input {
        background: transparent;
        margin-right: 10px;
        padding-left: 18px;
        width: 100%;
        height: 100%;
        border: none;
        //padding-left: 20px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #000000;
        outline: none;

        &:focus {
          //border: 1px solid #DC811D;
        }

        &::placeholder {
          line-height: 24px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #b6b6b6;
        }
      }

      .computer_pay_container_step_account_success {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .computer_pay_container_step_account_submit {
        padding: 6px 13px;
        box-sizing: border-box;
        background: #e68608;
        border-radius: 17px;
        border: 1px solid #e68608;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;

        position: relative;

        display: flex;
        align-items: center;
        justify-content: center;

        .computer_pay_container_step_account_submit_text {
          cursor: pointer;
          //position: absolute;
          //top: 50%;
          //left: 50%;
          //transform: translate(-50%, -50%);
          //z-index: 2;
        }

        .computer_pay_container_step_account_submit_img {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(80%, -50%);
          width: 33px;
          height: 18px;
          z-index: 1;
        }
      }

      .computer_pay_container_step_account_submit3 {
        margin-top: 10px;

        width: 220px;
        height: 46px;
        background: #E68608;
        border-radius: 23px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;

        .computer_pay_container_step_account_submit_text {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        }

        .computer_pay_container_step_account_submit_text_img {
          position: absolute;
          right: 9px;
          top: 50%;
          transform: translateY(-50%);
          width: 28px;
          height: 28px;
        }
      }
    }
  }

  .computer_pay_container_result {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 80px;
    box-sizing: border-box;
    padding-left: 145px;
    margin-top: 16px;

    height: 110px;
    background: #f2f2f2;

    display: none;

    .computer_pay_container_result_info {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #777777;

      .computer_pay_container_result_info_content {
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          color: #dc811d;
          font-size: 18px;
          margin-left: 10px;
        }
      }

      .computer_pay_container_result_info_amount {
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #e68608;
        margin-left: 6px;
      }

      .computer_pay_container_result_info_btn {
        cursor: pointer;
        padding: 4px;
        box-sizing: border-box;

        margin-left: 34px;

        background: rgba(230, 134, 8, 0.08);
        border-radius: 15px;
        border: 1px solid #e68608;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #e68608;
      }
    }
  }

  .computer_pay_container_result_submit {
    cursor: pointer;
    position: relative;
    margin: 0 auto;
    margin-top: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 350px;
    height: 80px;
    background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
    border-radius: 18px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 25px;
    color: #895c25;

    display: none;

    .computer_pay_container_result_submit_text {
      transform: translateX(16px);
    }

    .computer_pay_container_result_submit_img {
      width: 24px;
      height: 13px;
      transform: translateX(8px) translateY(2px);
    }
  }

  .computer_pay_container_tips {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin-top: 15px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #888888;

    display: none;

    .computer_pay_container_tips_img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
}

.computer_pay_payment_account_popup {
  .computer_pay_payment_account_popup_main {
    width: 1020px;
    background: #ffffff;
    border-radius: 15px;
    overflow: hidden;

    .paymentMethod {
      .paymentMethod_title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #7f7870;
        margin-top: 43px;
        margin-left: 100px;
      }

      .paymentMethod_box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 100px;
        margin-top: 20px;

        .paymentMethod_item {
          position: relative;
          width: 248px;
          height: 152px;
          background: #ffffff;
          box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          border: 1px solid #cccccc;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin: 0 24px;
          overflow: hidden;

          .paymentMethod_item_logo {
            width: 66px;
            height: 66px;
          }

          .paymentMethod_item_name {
            width: 100%;
            text-align: center;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 22px;
            color: #736b5a;
          }

          .paymentMethod_item_true {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 48px;
            height: 48px;
          }
        }

        .paymentMethod_item_s {
          background: rgba(246, 136, 52, 0.08);
          box-shadow: 0px 2px 10px 0px rgba(255, 112, 0, 0.2);
          border-radius: 8px;
          border: 1px solid #dba95a;
        }
      }
    }

    .computer_pay_payment_account_popup_main_close {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }

    .computer_pay_payment_account_popup_main_logo {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 50px;
      box-sizing: border-box;

      .computer_pay_payment_account_popup_main_logo_img {
        height: 100px;
        border-radius: 15px;
      }
    }

    .computer_pay_payment_account_popup_main_title {
      padding-top: 40px;
      margin-left: 80px;
      margin-right: 80px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #555555;

      .computer_pay_payment_account_popup_main_title_img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }

    .computer_pay_payment_account_popup_main_desc {
      margin-left: 80px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #888888;
      line-height: 40px;
    }

    .computer_pay_payment_account_popup_main_detail_title {
      padding-top: 30px;
      margin-left: 30px;
      margin-bottom: 30px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #524535;
    }

    .computer_pay_payment_account_popup_main_collect_box {
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 40px 0;
      box-sizing: border-box;

      .computer_pay_payment_account_popup_main_collect_num {
        width: 100%;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #7f7870;
      }

      .computer_pay_payment_account_popup_main_collect_total {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #776a5a;

        span {
          color: #dc811d;
          margin-left: 6px;
        }

        .computer_pay_payment_account_popup_main_collect_total_amount {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 30px;
        }

        .computer_pay_payment_account_popup_main_collect_total_detail {
          cursor: pointer;
          padding: 4px 15px;
          box-sizing: border-box;
          background: rgba(51, 51, 51, 0.12);
          border-radius: 15px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #555555;
          margin-left: 8px;
        }

        .computer_pay_payment_account_popup_main_collect_total_edit {
          cursor: pointer;
          padding: 6px 15px;
          box-sizing: border-box;
          background: rgba(220, 129, 29, 0.12);
          border-radius: 18px;
          margin-left: 8px;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #dc811d;

          display: flex;
          align-items: center;
          justify-content: center;

          .computer_pay_payment_account_popup_main_collect_total_edit_img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
          }
        }
      }
    }

    .computer_pay_payment_account_popup_main_collect_confirm_box {
      background: rgba(122, 122, 122, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 40px 0;
      box-sizing: border-box;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #7f7870;

      span {
        color: #dc811d;
        margin: 0 6px;
      }
    }

    .computer_pay_payment_account_popup_main_cur_account {
      margin-left: 80px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #776a5a;

      span {
        color: #dc811d;
        margin-left: 6px;
      }
    }

    .computer_pay_payment_account_popup_main_wait_amount {
      margin-top: 30px;
      margin-left: 80px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #555555;

      span {
        color: #dc811d;
        margin-left: 6px;
      }

      .computer_pay_payment_account_popup_main_wait_amount_num {
        font-size: 30px;
      }
    }

    .computer_pay_container_step_account {
      margin-top: 20px;
      align-items: center;
      margin-left: 80px;
      margin-right: 80px;

      .computer_pay_container_step_account_input_box {
        width: 100%;
        border-radius: 15px;
        border: 1px solid #aaaaaa;
        display: flex;
        align-items: center;
        margin-right: 20px;
      }

      .computer_pay_container_step_233 {
        width: 100px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #dc811d;
        text-align: center;
      }

      .computer_pay_container_step_account_input {
        margin-right: 10px;
        width: 100%;
        height: 80px;
        border: none;
        //padding-left: 20px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #dc811d;

        outline: none;

        &:focus {
          //border: 1px solid #DC811D;
        }

        &::placeholder {
          color: #bbbbbb;
        }
      }
    }

    .computer_pay_container_step_account2 {
      .computer_pay_container_step_account_input_box {
        padding-left: 20px;

        .computer_pay_container_step_account_input {
          border-radius: 15px;
        }
      }
    }

    .computer_pay_container_step_pay_account {
      margin-top: 30px;
      padding: 20px 0;
      background: rgba(218, 91, 91, 0.1);
      padding-left: 100px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #da5b5b;

      .computer_pay_container_step_pay_account_img {
        width: 24px;
        height: 24px;
        margin-right: 6px;
      }
    }

    .computer_pay_container_step_account_submit {
      cursor: pointer;
      position: relative;
      margin: 0 auto;

      display: flex;
      align-items: center;
      justify-content: center;

      margin-top: 30px;

      width: 243px;
      height: 80px;
      background: linear-gradient(
              180deg,
              #f6d07f 0%,
              #d78d2a 100%,
              #d47000 100%
      );
      border-radius: 40px;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 25px;
      color: #ffffff;

      .computer_pay_container_step_account_submit_text {
      }

      .computer_pay_container_step_account_submit_img {
        width: 19px;
        height: 16px;
        margin-left: 10px;
      }
    }

    .computer_pay_container_step_account_submit2 {
      width: 393px;
    }

    .computer_pay_payment_account_popup_main_confirm_box {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .computer_pay_payment_account_popup_close_box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .computer_pay_payment_account_popup_close {
      cursor: pointer;
      width: 50px;
      height: 50px;
    }
  }
}

.computer_pay_payment_account_verify_popup {
  .computer_pay_payment_account_verify_popup_main {
    width: 700px;
    background: #ffffff;
    border-radius: 15px;
    padding: 50px 42px;
    box-sizing: border-box;
    overflow: hidden;

    .computer_pay_payment_account_verify_popup_main_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #555555;
      margin-bottom: 40px;
    }

    .computer_pay_payment_account_verify_popup_main_item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 20px;
      padding: 0 8px;
      box-sizing: border-box;

      .computer_pay_payment_account_verify_popup_main_item_label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 30px;
        color: #777777;
        margin-right: 5px;
      }

      .computer_pay_payment_account_verify_popup_main_item_value {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 32px;
        color: #e68608;
      }
    }

    .computer_pay_payment_account_verify_popup_main_btnBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 60px;
      box-sizing: border-box;
      margin-top: 52px;

      .computer_pay_payment_account_verify_popup_main_btn {
        cursor: pointer;
        width: 220px;
        height: 80px;
        background: rgba(246, 136, 52, 0.08);
        box-shadow: 0px 2px 10px 0px rgba(255, 112, 0, 0.2);
        border-radius: 15px;
        border: 1px solid #dba95a;
        display: flex;
        align-items: center;
        justify-content: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 25px;
        color: #977d5d;

        box-sizing: border-box;
      }

      .computer_pay_payment_account_verify_popup_main_btn2 {
        background: linear-gradient(180deg, #ecd2a1 0%, #d4b077 100%);
        color: #895c25;
        border: none;
        box-shadow: none;
      }

      .computer_pay_payment_account_verify_popup_main_btn2_ban {
        pointer-events: none;
        background: #e0e0e0;
        color: #666666;
      }
    }
  }
}

.data-box {
  .th-row {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 86px;
    background: rgba(122, 122, 122, 0.1);
    border-radius: 15px 15px 0px 0px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #524535;
  }

  .td-row {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #7f7870;
  }

  ::v-deep .van-col {
    flex: 1;
    text-align: center;
  }
}

// 超出 1 行显示省略号
.common-ellipsis {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

// 滚动条位置 --展示的是竖向
// /deep/.__bar-is-vertical {
// right: -1px !important;
// }
// // 隐藏横向滚动条
// /deep/.__bar-is-horizontal {
// display: none !important;
// }

// 滚动条位置 --展示横向
:deep(.__bar-is-vertical) {
  display: none !important;
}

// 隐藏横向滚动条
:deep(.__bar-is-horizontal) {
  bottom: -1px !important;
}
</style>
<style lang="scss">
.computer_pay_container_step_item_value_label_popover_text {
  width: 300px;
  padding: 8px;
}


.computer_pay_container_step_item_value_label_icon {
  color: #dc811d;
}
</style>
